export const EVENT_CATEGORY = 'Article'

export const EVENT_ACTIONS = {
    CLICK: 'group of links click',
    VIEWABLE: 'group of links viewable impression',
    EMBED: 'group of links embed',
}

export const EVENT_LABELS = {
    NAME: 'group_of_links_name',
    PLACEMENT: 'component_placement',
    LINKS: 'number_of_links',
    POSITION: 'link_position',
    URL: 'click_link_url',
    IMAGE: 'has_image',
}

export const OBSERVER_CONFIG = {
    root: null,
    rootMargin: '0px',
    threshold: 1,
}
